import { useEffect } from 'react';
import { useMapEvents } from 'react-leaflet';
import * as L from 'leaflet';
import type { ClickMode } from '../../models/click-mode';

export interface MapEventsProps {
  onMapClick: (coordinates: L.LatLng) => void;
  onMapMove: (center: L.LatLng, zoom: number) => void;
  onZoom: (center: L.LatLng, zoom: number) => void;
  clickMode: ClickMode;
}

// Component to handle map events
const MapEvents = ({ onMapClick, onMapMove, onZoom, clickMode }: MapEventsProps): JSX.Element => {
  const map = useMapEvents({
    click: (e) => {
      if (clickMode === 'add-drop-point') {
        onMapClick(e.latlng);
      }
    },
    moveend: () => {
      onMapMove(map.getCenter(), map.getZoom());
    },
    zoomend: () => {
      onZoom(map.getCenter(), map.getZoom());
    },
  });

  useEffect(() => {
    map.getContainer().style.cursor = clickMode === 'add-drop-point' ? 'crosshair' : '';
  }, [clickMode, map]);

  return null;
};

export default MapEvents;
